// extracted by mini-css-extract-plugin
module.exports = {"outer":"FlexCallout_outer__h_WQ8","calloutContent":"FlexCallout_calloutContent__xPdR6","sectionHeading":"FlexCallout_sectionHeading__jYiB2"};